import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  edit: {
    id: 'studio.wEQDC6',
    defaultMessage: 'Edit',
  },
  details: {
    id: 'studio.Lv0zJu',
    defaultMessage: 'Details',
  },
  cancelButton: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  editButton: {
    id: 'studio.BWpuKl',
    defaultMessage: 'Update',
  },
  editTitle: {
    id: 'studio.Qt+S+L',
    defaultMessage: 'Editing {resource} {id}',
  },
  updateError: {
    id: 'studio.hB8k+Z',
    defaultMessage: 'Something went wrong when updating this resource.',
  },
  updateSuccess: {
    id: 'studio.71o4N1',
    defaultMessage: 'Successfully updated resource {id}.',
  },
  deleteButton: {
    id: 'studio.K3r6DQ',
    defaultMessage: 'Delete',
  },
  resourceWarningTitle: {
    id: 'studio./YHD8C',
    defaultMessage: 'Deletion warning',
  },
  resourceWarning: {
    id: 'studio.GYTZhK',
    defaultMessage:
      'Are you sure you want to delete this resource? Deleted resources can not be recovered.',
  },
  deleteSuccess: {
    id: 'studio.eky97D',
    defaultMessage: 'Successfully deleted resource {id}.',
  },
  deleteError: {
    id: 'studio.mt3K/p',
    defaultMessage: 'Something went wrong when deleting this resource.',
  },
});
